export default {
  nav: {
    home: 'Home',
    manufacturers: 'Hersteller',
    products: 'Produkte',
    about: 'Über uns',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Kontakt',
    getQuote: 'Angebot anfordern',
  },
  langModal: {
    title: 'Wir sind global',
    chooseLocation: 'Wählen Sie Ihren Standort',
  },
  header: {
    email: "deutschland{'@'}gmgautomation.net",
    phone: '+39 040 957 1064',
    language: 'Deutsch',
    searchPlaceholder: 'Suchen Sie nach Teilenummer oder Hersteller',
    noResults: 'Keine Teile gefunden',
    enquiryLink: 'Anfrage senden',
    enquiryLinkSub: 'Finden Sie Ihr Teil nicht? Lassen Sie es uns wissen',
  },
  quoteDrawer: {
    title: 'Senden Sie eine Anfrage',
    parts: 'Artikelnummer',
    addPart: 'Weiteren Artikel hinzufügen',
  },
  home: {
    hero: {
      title:
        'Suchen Sie nach der Teilenummer und finden Sie {highlight} sowie aktuelle Ersatzteile für die Automatisierung',
      highlight: 'abgekündigte',
      subtitle:
        'Entdecken Sie unsere breite Produktpalette für alle Ihre Anforderungen, darunter Steuerungen, SPS, HMIs, Motoren, Encoder, Servoantriebe, Wechselrichter, CNC-Systeme und vieles mehr',
      searchPlaceholder: 'Teilenummer eingeben...',
      search: 'Suchen',
    },
    manufacturers: {
      title: 'Hersteller',
      subtitle:
        'Unser umfangreicher Bestand umfasst Tausende von Automatisierungs- und Steuerungskomponenten von erstklassigen OEMs und ist somit eine Komplettlösung für Ihre Anforderungen. Wenn ein Teil nicht auf Lager ist, können Sie sicher sein, dass unser mehrsprachiges Team weltweit nach genau der Komponente sucht, die Sie benötigen, und dies zum wettbewerbsfähigsten Preis.',
      viewProducts: 'Produkte ansehen',
      viewAll: 'Alle Hersteller anzeigen',
    },
    whyUs: {
      title: 'Warum GMG Automation?',
      subtitle: 'Die Werte, die uns zu einem vertrauenswürdigen Partner für industrielle Automatisierung machen',
      quality: {
        title: 'Qualitätsservice',
        description: 'Freundlicher und erfahrener Kundenservice für schnelle und effiziente Lösungen.',
      },
      shipping: {
        title: 'Schnelle Lieferung',
        description: 'Lieferung am selben Tag für vorrätige Teile oder Expressversand aus unserem globalen Netzwerk.',
      },
      warranty: {
        title: '12 Monate Garantie',
        description:
          'Wir bieten 12 Monate Garantie auf alle Teile, egal ob neu, generalüberholt, repariert oder im Service-Austausch.',
      },
    },
    services: {
      title: 'Dienstleistungen',
      subtitle: 'Komplettlösungen für Ihren Ersatzteilbedarf in der Automatisierung',
      learnMore: 'Mehr erfahren',
      supply: {
        title: 'Lieferung',
        description:
          'Wir kümmern uns darum, Ihr Teil aus unserem Lager oder von unserem Lieferanten direkt an Ihre Haustür zu liefern.',
      },
      exchange: {
        title: 'Service-Austausch',
        description:
          'Wir nehmen Ihr defektes Gerät zurück und tauschen es gegen ein stark reduziertes, getestetes und funktionsfähiges Gerät ein.',
      },
      repair: {
        title: 'Reparatur',
        description: 'Wir können Tausende von Produkten zu Festpreisen reparieren.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Hersteller suchen...',
    noResults: 'Keine Hersteller gefunden',
    hero: {
      title: 'Hersteller',
      subtitle: 'Entdecken Sie unser breites Herstellersortiment und prüfen Sie die Verfügbarkeit tausender Produkte',
      badges: {
        warranty: { title: '12 Monate Garantie', subtitle: 'Auf alle gelieferten Teile' },
        response: { title: 'Schnelle Antwort', subtitle: 'Innerhalb von 24 Stunden' },
        delivery: { title: 'Weltweite Lieferung', subtitle: 'Versand weltweit' },
      },
    },
    products: {
      hero: {
        subtitle: 'Sie finden nicht, wonach Sie suchen? Rufen Sie uns an oder senden Sie uns eine Anfrage',
      },
      searchPlaceholder: 'Nach Teilenummer suchen...',
      showingEntries: '{from}–{to} von {total} Teilen angezeigt',
      noResults: 'Keine Teile gefunden',
    },
  },
  about: {
    hero: {
      title: 'Unser Ziel bei GMG Automation',
      subtitle:
        'Automatisierungs-Ersatzteillösungen finden, um Ausfallzeiten oder lange Vorlaufzeiten von OEMs zu minimieren',
    },
    values: {
      fast: {
        title: 'Schnell',
        desc: 'Wir sind für unsere schnelle Reaktion bekannt. Wir sind stolz darauf, schnell auf die Bedürfnisse unserer Kunden einzugehen und sicherzustellen, dass Ihre Automatisierungssysteme mit minimaler Verzögerung wieder die Höchstleistung erreichen.',
      },
      friendly: {
        title: 'Freundlich',
        desc: 'Erleben Sie einen beispiellosen Kundenservice mit unserem freundlichen, engagierten Team, das Ihnen jederzeit mit einem Lächeln zur Seite steht und Ihre Reise mit uns reibungslos und zufriedenstellend gestaltet.',
      },
      experienced: {
        title: 'Erfahren',
        desc: 'Dank unserer langjährigen Branchenerfahrung bieten wir fachkundige Beratung und hochwertige Lösungen und sind damit Ihr vertrauenswürdiger Partner bei der Bereitstellung von Automatisierungs-Ersatzteilen.',
      },
      reliable: {
        title: 'Zuverlässig',
        desc: 'Zuverlässigkeit steht im Mittelpunkt unserer Geschäftstätigkeit. Wir bieten zuverlässige Automatisierungs-Ersatzteillösungen, denen Sie jederzeit vertrauen können.',
      },
    },
    story1: {
      title: 'Lösungen für Ihre Produktivität zu finden, ist unser oberstes Ziel',
      text: 'Unser Team hat es geschafft, die Bedürfnisse der Branche zu verstehen und zuverlässige Dienstleistungen zu schaffen. GMG Automation liegt das Anliegen ihrer Kunden am Herzen, die Lösungen für Maschinenausfälle oder den Bedarf an obsoleten Ersatzteilen suchen. Deshalb haben wir ein weltweites Lieferantennetzwerk aufgebaut, um kostengünstige und schnelle Lösungen anbieten zu können.',
    },
    story2: {
      title: 'Wir schaffen zuverlässige Dienste, die allen dienen',
      text: 'Mit mehr als 10 Jahren Erfahrung in der Automatisierungsbranche und einem mehrsprachigen Team, das Ihnen zur Verfügung steht, lassen wir Sie nicht im Stich!',
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Entdecken Sie die neuesten Neuigkeiten, Trends und Einblicke unseres Teams',
    },
    empty: 'Keine Artikel gefunden.',
    back: 'Zurück zum Blog',
    label: 'Artikel',
    related: 'Weitere Artikel',
  },
  faq: {
    hero: {
      title: 'FAQ',
      subtitle: 'Lesen Sie unsere häufig gestellten Fragen',
    },
    search: 'Häufig gestellte Fragen durchsuchen',
    empty: 'Keine häufig gestellten Fragen gefunden.',
  },
  contact: {
    hero: {
      title: 'Kontaktieren Sie uns',
      subtitle:
        'Bei GMG Automation sind wir mehr als nur Händler für Automatisierungs-Ersatzteile: Wir sind Ihre engagierten Partner für Ihren Erfolg. Mit einem engagierten, mehrsprachigen Team stehen wir Ihnen für alle Anfragen gerne zur Verfügung',
    },
    offices: {
      title: 'Unsere Büros',
    },
    form: {
      title: 'Kontakt aufnehmen',
      name: 'Name',
      company: 'Firmenname',
      email: 'E-Mail-Adresse',
      nameRequired: 'Name ist erforderlich.',
      companyRequired: 'Firmenname ist erforderlich.',
      emailRequired: 'E-Mail ist erforderlich.',
      phoneRequired: 'Telefon ist erforderlich.',
      phone: 'Telefonnummer',
      phonePlaceholder: 'z. B. +49 30 12345678',
      message: 'Bitte teilen Sie uns die Details Ihrer Anfrage mit',
      send: 'Senden',
      sending: 'Wird gesendet...',
      successTitle: 'Nachricht gesendet',
      successDetail: 'Wir werden uns so schnell wie möglich bei Ihnen melden.',
      errorTitle: 'Fehler',
      errorDetail: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    },
    plantAddresses: {
      title: 'Adresse und Bankverbindung',
      regNumber: 'Handelsregisternummer',
      phone: 'Telefon',
      bankDetails: 'Bankverbindung',
      beneficiary: 'Begünstigter',
    },
  },
  terms: {
    hero: {
      title: 'Allgemeine Geschäftsbedingungen',
    },
    empty: 'Keine Allgemeinen Geschäftsbedingungen gefunden.',
  },
  privacy: {
    hero: {
      title: 'Datenschutzerklärung',
    },
    empty: 'Keine Datenschutzerklärung gefunden.',
  },
  cookie: {
    hero: { title: 'Cookie-Richtlinie' },
    empty: 'Keine Cookie-Richtlinie gefunden.',
    banner: {
      message:
        'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch weiteres Surfen stimmen Sie der Verwendung von Cookies zu.',
      learnMore: 'Cookie-Richtlinie',
      necessaryOnly: 'Nur Notwendige',
      acceptAll: 'Alle akzeptieren',
    },
  },

  product: {
    manufacturer: 'Hersteller',
    partNumberLabel: 'Teilenummer',
    noDescription: 'Keine Beschreibung verfügbar',
    inStock: 'Auf Lager',
    available: 'Verfügbar',
    qty: 'Menge',
    addToCart: 'zum Warenkorb hinzufügen',
    addedToCart: 'Zum Warenkorb hinzugefügt',
    enquiryTitle: 'Schnellanfrage ',
    warrantyText: 'Alle Produkte haben 12 Monate Garantie.',
    fetchError: 'Produkt konnte nicht geladen werden.',
    trust: {
      warranty: '12 Monate Garantie auf alle Produkte',
      shipping: 'Schneller weltweiter Versand',
      support: 'Professioneller Kundenservice',
    },
    features: {
      quality: 'Qualitätsprodukt',
      delivery: 'Schnelle Lieferung',
      warranty: '12 Monate Garantie',
    },
    tabs: {
      description: 'Beschreibung',
      warranty: 'Garantie',
    },
  },

  enquiryForm: {
    companyName: 'Name der Firma',
    yourName: 'Ihr Name',
    email: 'Email',
    country: 'Land auswählen',
    partNumber: 'Artikelnummer',
    quantity: 'Menge',
    send: 'Senden',
    phoneInput: {
      placeholder: 'Telefon',
      searchPlaceholder: 'Suchen',
    },
    successTitle: 'Anfrage gesendet',
    successDetail: 'Wir werden uns in Kürze bei Ihnen melden.',
    errorTitle: 'Etwas ist schiefgelaufen',
    errorDetail: 'Bitte versuchen Sie es später erneut.',
  },

  searchEnquiry: {
    title: 'Suchergebnisse für',
    whatNext: {
      title: 'Was passiert als nächstes?',
      step1Title: '1. E-Mail-Bestätigung',
      step1Text: 'Sie erhalten eine E-Mail zur Bestätigung, dass wir Ihre Anfrage erhalten haben.',
      step2Title: '2. Persönlicher Account Manager',
      step2Text:
        'Einer unserer Mitarbeiter wird sich mit Ihnen in Verbindung setzen, um die Spezifikationen und den Zustand Ihres Teils bzw. Ihrer Teile zu bestätigen.',
      step3Title: '3. Ihr Angebot',
      step3Text: 'Sie erhalten ein umfassendes Angebot, das auf Ihre spezifischen Bedürfnisse zugeschnitten ist.',
      legal: 'Alle Bestellungen unterliegen der Produktverfügbarkeit.',
      legalLink: 'Bitte beachten Sie unsere Allgemeinen Geschäftsbedingungen.',
      askTeam: 'Fragen an unser Team',
      emailLabel: 'Email',
    },
  },

  cart: {
    title: 'Anfragekorb',
    empty: 'Ihr Warenkorb ist leer',
    emptySub: 'Fügen Sie Teile von den Produktseiten hinzu, um zu beginnen',
    browse: 'Teile durchsuchen',
    itemCount: '{count} Teil | {count} Teile',
    partNumber: 'Teilenummer',
    availability: 'Verfügbarkeit',
    quantity: 'Menge',
    clearAll: 'Alles löschen',
    clearTitle: 'Warenkorb leeren',
    clearConfirm: 'Sind Sie sicher, dass Sie alle Artikel aus dem Warenkorb entfernen möchten?',
    clear: 'Löschen',
    cancel: 'Abbrechen',
    enquirySubtitle: '{count} Teil in Ihrer Anfrage | {count} Teile in Ihrer Anfrage',
    addedTitle: 'Zum Warenkorb hinzugefügt',
    addedDetail: '{partNumber} wurde zu Ihrem Anfrage-Warenkorb hinzugefügt',
  },

  footer: {
    contact: {
      title: 'Nehmen Sie Kontakt auf',
      subtitle: 'Kontaktieren Sie uns telefonisch oder per Formular. Wir helfen Ihnen gerne weiter!',
      formTitle: 'Online-Formular senden',
      formSubtitle: 'Teilen Sie uns Ihre Anforderungen mit, und wir antworten innerhalb von 24 Stunden.',
      enquiry: 'Anfrage senden',
      callTitle: 'Rufen Sie uns an',
      callSubtitle: 'Sprechen Sie direkt mit unserem mehrsprachigen Team.',
    },
    sections: {
      manufacturers: 'Hersteller',
      quickLinks: 'Schnellzugriff',
      connect: 'Kontakt',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Alle Rechte vorbehalten',
      privacy: 'Datenschutzerklärung',
      terms: 'AGB',
    },
    recaptcha: 'Geschützt durch reCAPTCHA',
    recaptchaPrivacy: 'Datenschutzerklärung',
    recaptchaTerms: 'Nutzungsbedingungen',
    disclaimer:
      'GMG Automation ist weder ein Vertriebspartner noch ein autorisierter Vertreter der auf dieser Website genannten Marken. Die eingetragenen Marken und Namen auf dieser Website gehören ihren jeweiligen Eigentümern.',
  },

  common: {
    noResults: 'Keine Ergebnisse',
  },

  validation: {
    required: 'Dieses Feld ist erforderlich',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    tooLong: 'Darf nicht länger als {max} Zeichen sein',
    recaptchaError: 'Die reCAPTCHA-Überprüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Ersatzteile für Industrieautomatisierung',
      description: 'Finden Sie veraltete und aktuelle Ersatzteile für die Industrieautomatisierung. Suchen Sie nach Artikelnummer und fordern Sie innerhalb von 24 Stunden ein Angebot an. SPS, HMI, Servoantriebe und mehr.',
    },
    manufacturers: {
      title: 'Hersteller — GMG Automation',
      description: 'Durchsuchen Sie Automatisierungsersatzteile nach Hersteller. Siemens, ABB, Schneider Electric, Fanuc und Hunderte mehr. Schneller weltweiter Versand mit 12 Monaten Garantie.',
    },
    about: {
      title: 'Über Uns — GMG Automation',
      description: 'Über 10 Jahre Erfahrung in Ersatzteilen für Industrieautomatisierung. Mehrsprachiges Team, globales Lieferantennetzwerk, schnelle Reaktion und 12 Monate Garantie auf alle Teile.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Bleiben Sie mit den neuesten Nachrichten, Brancheneinblicken und technischen Artikeln des GMG Automation Teams auf dem Laufenden.',
    },
    faq: {
      title: 'FAQ — GMG Automation',
      description: 'Antworten auf häufig gestellte Fragen zu Bestellungen, Versand, Zahlung und Garantie bei GMG Automation.',
    },
    contact: {
      title: 'Kontakt — GMG Automation',
      description: 'Nehmen Sie Kontakt mit dem GMG Automation Team auf. Rufen Sie uns an, senden Sie eine Anfrage oder schreiben Sie uns direkt. Wir antworten innerhalb von 24 Stunden.',
    },
    terms: {
      title: 'AGB — GMG Automation',
      description: 'Lesen Sie die allgemeinen Geschäftsbedingungen für die Nutzung der GMG Automation Dienste und den Kauf von Industrieersatzteilen.',
    },
    privacy: {
      title: 'Datenschutzerklärung — GMG Automation',
      description: 'Erfahren Sie, wie GMG Automation Ihre personenbezogenen Daten gemäß den geltenden Datenschutzbestimmungen erhebt, verwendet und schützt.',
    },
    cookie: {
      title: 'Cookie-Richtlinie — GMG Automation',
      description: 'Erfahren Sie mehr über die auf der GMG Automation Website verwendeten Cookies und wie Sie Ihre Einstellungen verwalten können.',
    },
    product: {
      description: 'Kaufen Sie {partNumber} von {manufacturer}. Fordern Sie ein Angebot für eine schnelle weltweite Lieferung an. 12 Monate Garantie inklusive.',
    },
    manufacturerProducts: {
      description: 'Durchsuchen Sie {manufacturer} Ersatzteile und Automatisierungskomponenten. Suchen Sie nach Artikelnummer und fordern Sie ein Angebot mit schnellem weltweitem Versand an.',
    },
  },
}
